import InvestmentRepresentations from './InvestmentRepresentations'

export default InvestmentRepresentations
